export default __webpack_public_path__ + "static/portfolio-mas-4-dcce39d5815ecffc5d41dddc1d22e218.jpg";